export function resolveRelativeUrl(url) {
    // Funny trick.
    const a = document.createElement("a");
    a.href = url;
    return a.href;
}
//# sourceMappingURL=resolveRelativeUrl.js.map